export default __webpack_public_path__ + "static/media/estimate-01.305d8387.mp4";